export default __webpack_public_path__ + "static/media/closeIcon.2001e956.svg";